import * as constants from '@config/constants';
import productConfigs, { BUSINESSES } from '@config/products';
import { getRoleDisplayName } from '@utils/roles';

/**
 * Is the user authenticated? Returns true, false, or undefined (if the value is still being determined)
 * @param {Store} state
 */
export function isUserAuthenticated(state) {
  const isUserCheckComplete =
    state.xhr[constants.XHR_USERCHECK]?.isLoading === false;
  if (!isUserCheckComplete) {
    return undefined;
  }

  return !!state.auth.user;
}

export function getUserFullName(state) {
  return state.auth.user?.attributes?.name || '';
}

export function getUserEmail(state) {
  return state.auth.user?.attributes?.email || '';
}

export function getOrganization(state) {
  return state.organization;
}

/**
 * Free Trial Credits
 */
export function getTotalCredits(state) {
  return state.keys?.total_credits || 0;
}

export function getCreditsUsed(state) {
  return state.keys?.credits_spent || 0;
}

export function getCreditsRemaining(state) {
  return Math.max(getTotalCredits(state) - getCreditsUsed(state), 0);
}

/**
 * Subscription
 */
export function getSubscriptionStatus(state) {
  return state.keys?.subscription_status;
}

export function hasActiveSubscription(state) {
  return state.keys?.subscription_status === 'ACTIVE';
}

export function getApiKey(state) {
  return state.keys.key;
}

/**
 * Roles / Permissions
 */

const filterRolesByEnv = roleList => {

  if (!roleList || !Array.isArray(roleList) || roleList.length === 0) {
    return [];
  }

  const filteredRoles = [];
  roleList.forEach(role => {
    if(role == `${process.env.REACT_APP_ADMIN_GROUP}-Admin`){
      filteredRoles.push('Admin');
    }

    if(role == `${process.env.REACT_APP_ADMIN_GROUP}-View-only`){
      filteredRoles.push('View-only');
    }
  });
  return filteredRoles;
};

export function getUserRoles(state) {
  const accessToken = state.auth.user.signInUserSession.idToken;
  return filterRolesByEnv(accessToken.payload['cognito:groups'] || []);
}

// Returns the user's Cognito groups with the environment prefix stripped,
// e.g. `${REACT_APP_ADMIN_GROUP}-Admin` -> `Admin`
export function getUserGroups(state) {
  const idToken = state.auth.user?.signInUserSession?.idToken;
  const groups = idToken?.payload['cognito:groups'] || [];
  const prefix = `${process.env.REACT_APP_ADMIN_GROUP}-`;
  return groups.map(group =>
    group.startsWith(prefix) ? group.slice(prefix.length) : group
  );
}


// returns a string for the highest role the user has
export function getUserRole(state) {
  const roles = getUserRoles(state);
  return getRoleDisplayName(roles);
}

export function isOrganizationAdmin(state) {
  const roles = getUserRoles(state);

  return (
    roles.includes(constants.ROLE_ADMIN) || roles.includes(constants.ROLE_OWNER)
  );
}

export function isOrganizationOwner(state) {
  const roles = getUserRoles(state);

  return roles.includes(constants.ROLE_OWNER);
}

/**
 * API
 */

export function getBusinessesUsage(state) {
  const productConfig = productConfigs[BUSINESSES];
  return state.keys.api_usage_limits[productConfig.usagePlanName];
}
